import Vue from 'vue'
import store from '../../store/index'

// ================ 同浏览器多标签页操作不同系统 start


// 第一次打开新标签页、刷新页面也算第一次打开
if (!window.name) {
  systemChange(window.location.pathname);
}

// 监听浏览器旧标签页之间切换
document.addEventListener('visibilitychange', function() { //浏览器切换事件
  if (document.visibilityState == 'visible') { // 回到当前tab标签
    systemChange(window.location.pathname);
  }
});

// 系统数据切换
function systemChange(urlPath) {
  let current_token = localStorage.getItem('token');
  let init_store_type = -1;
  let system_name = '';
  let system_info = null;

  if (urlPath.indexOf('/admin/store_') != -1) {
    // 多商户系统 store_type==0
    system_name = 'SYSTEM_STORE';
    init_store_type = 0;
  } else if (urlPath.indexOf('/admin/clinic/') != -1 &&
    urlPath.indexOf('/admin/clinic/outpatient/') == -1) {
    // 门诊系统 store_type==3
    // 路由 /admin/clinic/outpatient/ 是私有管理系统的菜单功能
    system_name = 'SYSTEM_CLINIC';
    init_store_type = 3;
  } else if (urlPath.indexOf('/admin/private/') != -1) {
    // 私有部署管理后台系统 store_type==2
    system_name = 'SYSTEM_ADMIN';
    init_store_type = 2;
    // 移除应用系统信息
    localStorage.removeItem('apply_info');
    store.dispatch('setApplyInfo', {
      id: 0,
      store_id: ''
    })
  } else if ((urlPath.indexOf('/admin/mechanism/') != -1 || urlPath.indexOf('/device/mechanism_device_home') != -1) &&
    urlPath.indexOf('/mechanism/config/data_large_screen') == -1) {
    system_name = 'SYSTEM_MECHANISM';
    init_store_type = 4;
  } else {
    // 多应用系统，saas系统 store_type==1
    system_name = 'SYSTEM_SAAS_OR_APP';
    init_store_type = 1;
  }
  localStorage.setItem('store_type', init_store_type)
  // 多系统数据配置
  if (system_name != '') {
    system_info = localStorage.getItem(system_name);
    system_info = JSON.parse(system_info);
    if (system_info != null) {
      if (system_info.token != current_token) {
        localStorage.setItem('store_type', system_info.store_type);
        store.commit('update_type', system_info.store_type);
        localStorage.setItem('token', system_info.token);
        localStorage.setItem('aout_time', system_info.aout_time);
        localStorage.setItem('userInfo', JSON.stringify(system_info.userInfo));
        store.dispatch('setAdmin', system_info.userInfo);
        if (system_name === 'SYSTEM_ADMIN' || system_name === 'SYSTEM_SAAS_OR_APP') {
          Vue.Store_id = system_info.userInfo.store_id;
        }
      }
    } else {
      localStorage.removeItem('token');
    }
  }
}

// ================ 同浏览器多标签页操作不同系统 end


// WEBPACK FOOTER //
// ./src/assets/js/system.js